
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import React, { useState } from 'react';
import { IonGrid, IonRow, IonCol } from '@ionic/react';
import { personCircle } from "ionicons/icons";
import { useHistory } from "react-router-dom";
import { IonItem, IonLabel, IonInput, IonButton, IonIcon, IonAlert } from '@ionic/react';
import { ApiLogin } from '../apiproviders/dataprovider';
import { createStore } from '../data/persistent/IonicStore';
import { app } from '../configs/appcfg';
import '../i18n/config';


interface ILoginResult{
    isLoginValid: boolean;
    changePasswordRequired: boolean;
    mathisinh: string;
    passcode: string;
    token: string;
}
const Login: React.FC = () => {
  const history = useHistory();
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [iserror, setIserror] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [messageTitle, setMessageTitle] = useState<string>('Thông báo');
const handleLogin = async () => {
  console.log("login");
  if (!username || username.length === 0 || username ==="") {
    setMessageTitle('Thông báo');
    setMessage("Tên đăng nhập không hợp lệ");
      setIserror(true);
      return;
  }

  if (!password || password.length < app.rules.minPasswordLength) {
    setMessageTitle('Thông báo');  
    setMessage("Vui lòng nhập mật khẩu");
      setIserror(true);
      return;
  }

  const loginData = {
      "username": username,
      "password": password
  }
  try {
    let res = await ApiLogin(loginData);
    if([200].indexOf(res.status) !== -1){
      let loginResult: ILoginResult = res.data;
      //lưu dữ liệu xuống local store
      loginResult.isLoginValid = true;
      loginResult.changePasswordRequired = loginResult.mathisinh === loginResult.passcode
      let localStore = await createStore();
      await localStore.set("login_info", JSON.stringify(loginResult));
      if(loginResult.isLoginValid){
          if(loginResult.changePasswordRequired){
              history.push("/passwordchange");
          }else{
              
              history.push("/profile");
          }
      }else{
        setMessageTitle('Lỗi kết nối');
          setMessage("Lỗi kết nối! vui lòng kiểm tra đường truyền");
          setIserror(true);
      }   
    }
  } catch (error) {
    setMessageTitle('Lỗi xác thực');
    setMessage(`Bạn đã nhập sai mật khẩu hoặc mã số sinh viên, bấm vào <a href="/showinfo" target='_blank'>đây</a> để xem mật khẩu của mình. Nếu không được liên hệ zalo 0978.555.950 để hỗ trợ`);
    setIserror(true);
  }
};

return (
<IonPage>
  <IonHeader>
    <IonToolbar>
      <IonTitle>Đăng nhập</IonTitle>
    </IonToolbar>
  </IonHeader>
  <IonContent fullscreen className="ion-padding ion-text-center">
    <IonGrid>
    <IonRow>
      <IonCol>
        <IonAlert
            isOpen={iserror}
            onDidDismiss={() => setIserror(false)}
            cssClass="my-custom-class"
            header={messageTitle}
            message={message}
            buttons={["ĐÓNG"]}
        />
      </IonCol>
    </IonRow>
    <IonRow>
      <IonCol>
        <IonIcon
            style={{ fontSize: "70px", color: "#0040ff" }}
            icon={personCircle}
        />
      </IonCol>
    </IonRow>
      <IonRow>
        <IonCol>
        <IonItem>
        <IonLabel position="floating">{app.ui.login.username}</IonLabel>
        <IonInput
            type="text"
            value={username}
            onIonChange={(e) => setUsername(e.detail.value!)}
            >
        </IonInput>
        </IonItem>
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol>
        <IonItem>
          <IonLabel position="floating">{app.ui.login.password}</IonLabel>
          <IonInput
            type="password"
            value={password}
            onIonChange={(e) => setPassword(e.detail.value!)}
            >
          </IonInput>
        </IonItem>
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol>
          <IonButton expand="block" onClick={handleLogin}>Đăng nhập</IonButton>
        </IonCol>
      </IonRow>
    </IonGrid>
    <p >Lưu ý: Sinh viên xem <a  href='/HD_DKQUANTRANG.html' target="_blank" >hướng dẫn đăng ký quân trang </a> trước khi đăng nhập.</p>
    <p>Trường hợp sinh viên không nhớ mật khẩu. Hãy vào trang <a href='/showinfo' target='_blank'> hỗ trợ</a> để xem thông tin</p>
  </IonContent>
</IonPage>
);
};

export default Login;

